import { Button } from '@mui/material';
import styled from 'styled-components/macro';

export const ButtonStyled = styled(Button)`
  && {
    text-transform: none;
    border-radius: ${({ theme }) => theme.radius['2xl']};
    border-color: ${({ theme }) => theme.colors.primary.variant6};
    padding: 2px 12px;
    font-size: ${({ theme }) => theme.fontSize.sm};
  }
`;
